import { __decorate } from "tslib";
import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators';
import store from '@blade/common/store';
import { handleError } from '@blade/common/utils/handle-error';
import { getVirtualZoneTagTree, getClusterVisitorType } from '@blade-sxp/portrait-center/api/index';
import { fetchZoneTree } from '@blade/common-ui/map-old/2d/src/api';
import { isEmpty } from 'lodash';
const virtualZoneName = (tree) => {
    const deep = (datas) => {
        if (!isEmpty(datas)) {
            const data = datas.map((item) => {
                return {
                    type: item?.tagType || item?.taskType,
                    value: item?.tagType === 'ENTIRE_ZONE' ? item?.list[0]?.taskId : item?.tagId || item?.taskId,
                    label: item?.tagName || item?.taskName,
                    disabled: !(item?.list?.length > 0) && item?.tagId,
                    children: item?.tagType !== 'ENTIRE_ZONE' && item?.list && item?.list?.length > 0 ? deep(item?.list) : null,
                };
            });
            return data;
        }
    };
    return deep(tree);
};
let PortraitCenter = class PortraitCenter extends VuexModule {
    activeTab = ''; // VIRTUAL_AREA || MAP
    dates = {
        dateStart: '',
        dateEnd: '',
    };
    zoneId = 0;
    zoneData = {
        parent: {
            id: 1,
            name: '',
        } || null,
    };
    zoneTree = [];
    zoneVirtualTree = [];
    apiRequestNum = 0; // 接口请求数量返回统计
    clusterType = 'none'; // rtc 实时聚类 30天; offline 离线聚类 365天; none 没有聚类
    updateClusterType(data) {
        this.clusterType = data;
    }
    updateApiRequestNum(num) {
        if (num === 0 && this.apiRequestNum < 10) {
            return false;
        }
        this.apiRequestNum = num ?? this.apiRequestNum + 1;
    }
    updateActiveTab(val) {
        this.activeTab = val;
    }
    updateDates(val) {
        const { dateStart, dateEnd } = val;
        this.dates.dateStart = dateStart;
        this.dates.dateEnd = dateEnd;
    }
    updateCurrentZoneId(val) {
        this.zoneId = val;
        PortraitCenterModule.updateApiRequestNum(0);
    }
    updateZoneTree(val) {
        this.zoneTree = [val];
        this.zoneData.parent = val;
    }
    updateZoneVirtualTree(val) {
        this.zoneVirtualTree = val;
        this.zoneVirtualTree.forEach((item) => {
            if (item.type === 'ENTIRE_ZONE') {
                this.zoneId = Number(item.value) || 0;
                PortraitCenterModule.updateApiRequestNum(0);
            }
        });
    }
    getActiveTab(val) {
        try {
            return this.updateActiveTab(val);
        }
        catch (err) {
            handleError(err);
        }
    }
    getDates(val) {
        try {
            return this.updateDates(val);
        }
        catch (err) {
            handleError(err);
        }
    }
    getCurrentZoneId(val) {
        return this.updateCurrentZoneId(val);
    }
    getFetchZoneTree() {
        fetchZoneTree().then((res) => {
            this.updateZoneTree(res);
            this.updateCurrentZoneId(Number(res.id));
        });
    }
    getVirtualZoneTagTree() {
        try {
            getVirtualZoneTagTree({
                excludeNonRecognitionTask: true,
            }).then((res) => {
                // const result = [
                //   {
                //     tagId: '362489005039616',
                //     tagName: 'subzone-xy',
                //     tagType: 'CUSTOM_ZONE',
                //     list: [
                //       {
                //         taskType: 'VIRTUAL_ZONE_STATISTIC',
                //         zoneId: '87509881626624',
                //         taskId: '465221703524352',
                //         taskName: 'subzone1',
                //         taskStatus: 'ENABLE',
                //       },
                //     ],
                //   },
                // ];
                this.updateZoneVirtualTree(virtualZoneName(res));
            });
        }
        catch (err) {
            handleError(err);
        }
    }
    getFuncClusterVisitorType() {
        try {
            getClusterVisitorType().then((res) => {
                this.updateClusterType(res);
            });
        }
        catch (err) {
            handleError(err);
        }
    }
};
__decorate([
    Mutation
], PortraitCenter.prototype, "updateClusterType", null);
__decorate([
    Mutation
], PortraitCenter.prototype, "updateApiRequestNum", null);
__decorate([
    Mutation
], PortraitCenter.prototype, "updateActiveTab", null);
__decorate([
    Mutation
], PortraitCenter.prototype, "updateDates", null);
__decorate([
    Mutation
], PortraitCenter.prototype, "updateCurrentZoneId", null);
__decorate([
    Mutation
], PortraitCenter.prototype, "updateZoneTree", null);
__decorate([
    Mutation
], PortraitCenter.prototype, "updateZoneVirtualTree", null);
__decorate([
    Action({ rawError: true })
], PortraitCenter.prototype, "getActiveTab", null);
__decorate([
    Action({ rawError: true })
], PortraitCenter.prototype, "getDates", null);
__decorate([
    Action({ rawError: true })
], PortraitCenter.prototype, "getCurrentZoneId", null);
__decorate([
    Action({ rawError: true })
], PortraitCenter.prototype, "getFetchZoneTree", null);
__decorate([
    Action({ rawError: true })
], PortraitCenter.prototype, "getVirtualZoneTagTree", null);
__decorate([
    Action({ rawError: true })
], PortraitCenter.prototype, "getFuncClusterVisitorType", null);
PortraitCenter = __decorate([
    Module({
        dynamic: true,
        store,
        name: 'senseXplorer/portraitCenter',
    })
], PortraitCenter);
export const PortraitCenterModule = getModule(PortraitCenter);
